import React from 'react';
import {Form} from 'react-form';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';
import moment from 'moment';
import NetworkService from 'services/NetworkService';
import {FormGroup, Text, Checkbox, DatePicker, TimePicker} from 'components/FormElements/';
import {toggleLoading, toggleAlertError} from 'stores/actions/';
import {required} from 'constants/InputErrors';

class NetworkForm extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
    this.authX = this.authX.bind(this);
  }

  componentDidMount() {
    if( this.entityId ) this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    NetworkService.getNetwork( this.entityId ).then( ( response ) => {
      this.props.toggleLoading( false );
      if (response.data) {
        const data = response.data;
        if (data && data.fromTwMessages) {
          const x = new Date(data.fromTwMessages)
          console.log('fromTwMessages', data.fromTwMessages)
          const y = String(data.fromTwMessages)
          const Hours = y.split('T')[1].split(':')[0]
          const Minutes = y.split('T')[1].split(':')[1]
          console.log('`${Hours}:${Minutes}`', `${Hours}:${Minutes}`)
          data.fromTwMessages =moment.utc(x.toISOString())

          data.fromTwMessagesTime = `${Hours}:${Minutes}`
        }

        this.setState( { data } )
      }
    } )
  }

  authX(apiKey) {
    const { urlWeb } = this.props;
    window.location.href = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${apiKey}&redirect_uri=${urlWeb}&scope=tweet.read%20users.read%20like.write%20tweet.write%20dm.read%20dm.write%20offline.access&state=1234567890&code_challenge=0987654321&code_challenge_method=plain`;
  
  }

  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading, type } = this.props;
    this.formData = _.cloneDeep( data );
    console.log('fromTwMessagesTime', data.fromTwMessagesTime);
    if (data && data.fromTwMessages) {
      
      
      let Time = moment(data.fromTwMessagesTime).format('HH:mm') 
      if (Time === 'Invalid date') {
        Time = data.fromTwMessagesTime; 
      }
      data.fromTwMessages = `${moment(data.fromTwMessages).format('YYYY-MM-DD')}T${Time}:00+00:00`;
    }

    toggleLoading( true );

    data.type = type;
    //if (data.twSinceId) { 
    //  data.twSinceId = data.twSinceId;
    //}
    if (data.twLimitTimeLine) { 
      data.twLimitTimeLine = parseInt(data.twLimitTimeLine, 10);
    }
    if (data.fbLimit) { 
      data.socialLimit = parseInt(data.fbLimit, 10);
      delete data.fbLimit;
    }
    if( this.entityId && !data.socialSecret ) {
      data.socialSecret = undefined;
    }
    if( this.entityId && !data.tokenSecret && type === 'twitter') {
      data.tokenSecret = undefined;
    }

    if ( type === 'phone' ) {
      //data.whatsappPhone = data.socialSecret;
      data.socialId = data.whatsappPhone;
      data.socialSecret = undefined
    }
    const promise = this.entityId ? NetworkService.updateNetwork( this.entityId, data ) :
      NetworkService.saveNetwork( data );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      return history.push( `/configurations/${type}` )
    } )
  }

  render() {
    const { type } = this.props;
    const { fromMentionsTimeLine, fromTwMessages, fromTwMessagesTime } = this.state;

    return (
      <div className="box box-default">
        <div className="box-header text-capitalize">{this.entityId ? <Translate id="edit"/> :
          <Translate id="new"/>} <Translate id="accountType" values={{type}}/></div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values  ) => {
              return {
                alias: required( values.alias ),
                socialId: type !== 'phone' ? required( values.socialId ) : null,
                socialSecret: this.entityId || type === 'phone' ? null : required( values.socialSecret ),
                whatsappPhone: type === 'phone' ?  required( values.whatsappPhone ) : null,
                tokenSecret: type === 'twitter' && !this.entityId ? required( values.tokenSecret ) : null,
                token: type === 'twitter' || type === 'facebook' ? required( values.token ) : null,
                fbPage: type === 'facebook' ? required(values.fbPage) : null,
                //accesToken : type === 'twitter' ? required( values.accesToken ) : null,
                //refreshToken : type === 'twitter' ? required( values.refreshToken ) : null,
                clientId : type === 'twitter' ? required( values.clientId ) : null,
                clientSecret : type === 'twitter' ? required( values.clientSecret ) : null,
                //twPage: type === 'twitter' ? required( values.twPage ) : null,
                fbLimit: type === 'twitter' ? required(values.fbLimit) : null,
                //fromMentionsTimeLine: type === 'twitter' ? required(values.fromMentionsTimeLine) : null,
                fromTwMessages: type === 'twitter' ? required(values.fromTwMessages) : null, 
        
              }
            }}>
            {( { getValue,submitForm } ) =>
              <form onSubmit={submitForm}>
                <FormGroup>
                  <label><Translate id="alias"/></label>
                  <Text field="alias" className="form-control"/>
                </FormGroup>
                {type !== 'phone' &&
                  <FormGroup>
                    <label><Translate id={type === 'twitter' ? 'tw.socialId' :'appId'}/></label>
                    <Text field="socialId" className="form-control"/>
                  </FormGroup>
                }
                {type !== 'phone' &&
                <FormGroup>
                  <label><Translate id={type === 'twitter' ? 'tw.socialSecret' :'appSecret'}/></label>
                  <Text field="socialSecret" className="form-control"/>
                </FormGroup>
                }
                {type === 'phone' &&
                <FormGroup>
                  <label><Translate id="phone"/></label>
                  <Text field="whatsappPhone" className="form-control"/>
                </FormGroup>
                }
                {type === 'facebook' &&
                <FormGroup>
                  <label><Translate id="page"/></label>
                  <Text field="fbPage" className="form-control"/>
                </FormGroup>
                }


                {type === 'twitter' &&
                  <FormGroup>
                    <label><Translate id="clientId" /></label>
                    <Text field="clientId" className="form-control" />
                  </FormGroup>
                }
                {type === 'twitter' &&
                  <FormGroup>
                    <label><Translate id="clientSecret" /></label>
                    <Text field="clientSecret" className="form-control" />
                  </FormGroup>
                }
                {type !== 'phone' &&
                  <FormGroup>
                    <label><Translate id={type === 'twitter' ? 'tw.token' :'token'}/></label>
                    <Text field="token" className="form-control" disabled={type !== 'twitter' && type !== 'facebook'}/>
                  </FormGroup>
                }
                {type === 'twitter' &&
                <FormGroup>
                  <label><Translate id="tw.tokenSecret"/></label>
                  <Text field="tokenSecret" className="form-control"/>
                </FormGroup>
                }
                <div className="row"> 
                  {type === 'twitter' &&
                    <FormGroup containerClass="col-md-3">
                      <label><Translate id="twSinceId" /></label>
                      <Text field="twSinceId" className="form-control" />
                    </FormGroup>
                  }
                  {type === 'twitter' &&
                    <FormGroup containerClass="col-md-3">
                      <label><Translate id="fromTwMessages" /></label>
                      <DatePicker field="fromTwMessages" value={fromTwMessages }  onChange={(value) => { this.setState({ fromTwMessages: value })}} clearable/>
                  </FormGroup>
                  }
                  {type === 'twitter' &&
                    <FormGroup containerClass="col-md-3">
                      <label><Translate id="fromTwMessagesTime" /></label>
                      <TimePicker field="fromTwMessagesTime" value={fromTwMessagesTime }  onChange={(value) => { this.setState({ fromTwMessagesTime: value })}} clearable/>
                  </FormGroup>
                  }
                  {type === 'twitter' &&
                    <FormGroup containerClass="col-md-2">
                      <label><Translate id="twLimitTimeLine" /></label>
                      <Text field="twLimitTimeLine" className="form-control" type="number" />
                    </FormGroup>
                  }
                  {type === 'twitter' &&
                    <FormGroup containerClass="col-md-1">
                      <label><Translate id="limit" /></label>
                      <Text field="fbLimit" className="form-control" type="number" />
                    </FormGroup>
                  }
                </div>
                {(type === 'twitter' && this.entityId)  &&
                  <FormGroup>
                    <label><Translate id="userID" /></label>
                    <Text field="twPage" className="form-control" disabled />
                  </FormGroup>
                }
                {(type === 'twitter' && this.entityId)  &&
                  <FormGroup>
                    <label><Translate id="accesToken" /></label>
                    <Text field="accesToken" className="form-control" disabled />
                  </FormGroup>
                }
                {(type === 'twitter' && this.entityId)  &&
                  <FormGroup>
                    <label><Translate id="refreshToken" /></label>
                    <Text field="refreshToken" className="form-control" disabled />
                  </FormGroup>
                }
                {type === 'facebook' && <hr className="mt-4"/>}

                {type === 'facebook' &&
                <FormGroup>
                  <label><Translate id="version"/></label>
                  <Text field="fbVersion" className="form-control" disabled/>
                </FormGroup>
                }

                {type === 'facebook' &&
                <FormGroup>
                  <label><Translate id="limit"/></label>
                  <Text field="fbLimit" className="form-control" disabled/>
                </FormGroup>
                }

                <div className="text-right mt-4">
                  {(type === 'twitter'  && this.entityId ) &&
                 
                    <button className={!getValue('twPage') ? "btn btn-danger  px-4 mr-2" :  "btn btn-outline-secondary  px-4 mr-2" } disabled={!getValue('clientId') || !getValue('clientSecret')} onClick={() => this.authX(getValue('clientId'))}>
                      <Translate id={!getValue('twPage') ? "authorizeApp" : "refreshAuth" } />
                    </button>
              
                  }
                  <Link to={`/configurations/${type}`}>
                    <button className="btn btn-outline-secondary px-4 mr-2">
                      <Translate id="cancel"/>
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}
const mapStateToProps = ( state, ownProps ) => ({
  urlWeb: state.settings.urlWeb,
});
const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( NetworkForm );



// WEBPACK FOOTER //
// ./routes/app/components/Configuration/NetworkForm/index.js